import {ENV_VARIABLES} from "./index";

export let ENV_PROD: ENV_VARIABLES = {
    APP_ENV: "prod",
    API_BASE: "https://azureapi.masholdings.com/tulitaclock",
    API_SCOPE: ["api://e969709d-afe9-481c-92f3-ace3fb068826/access_as_user"],
    AUTHORITY: "https://login.microsoftonline.com/852c5799-8134-4f15-9d38-eba4296cc76f",
    CLIENT_ID: "f122a039-2f5d-414c-9745-6584c98b1ae4",
    REDIRECT_URL: "https://tulitaclock.masholdings.com/login",
    APIM_SUBSCRIPTION_KEY: '3f42614720304ab48e524a73fbfa819c'
}
